export enum MyStoryState {
  drafted = 'drafted',
  published = 'published',
}
